// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1NI5S","ranges":"BmiRanges_ranges__16O5S"};